import { APIS } from 'src/lib/constants/apis';
import { EINSATZBEREICH } from 'src/lib/constants/constant';

export const getEinsatzbereichByApi = (api?: string | null): string | null => {
	if (api === APIS.Antrag) return EINSATZBEREICH.Antrag;
	if (api === APIS.Mittelabruf) return EINSATZBEREICH.Mittelabruf;
	if (api === APIS.Verwendungsnachweis) return EINSATZBEREICH.Verwendungsnachweis;
	return null;
};

export const withKostenkategorieEinsatzbereichFilter = (baseFilter: Record<string, any>, api?: string | null): Record<string, any> => {
	const einsatzbereich = getEinsatzbereichByApi(api);
	if (!einsatzbereich) return baseFilter;

	return {
		...baseFilter,
		Allgemein_Einsatzbereich: { $eq: einsatzbereich },
	};
};
